// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M22.976.05a.835.835 0 0 0-.221.137c-.053.049-3.505 4.96-7.67 10.913-6.365 9.097-7.601 10.85-7.747 10.992a1.333 1.333 0 0 1-.977.396c-.372-.001-.708-.125-.967-.358-.073-.066-.915-1.167-2.094-2.738-1.084-1.445-2.011-2.663-2.06-2.706a.65.65 0 0 0-.366-.174.746.746 0 0 0-.803 1.054c.064.125 3.95 5.308 4.129 5.505.246.272.678.568 1.043.714a2.964 2.964 0 0 0 3.45-.94c.256-.339 15.171-21.658 15.233-21.776.053-.102.062-.15.061-.324 0-.175-.01-.223-.064-.325a.76.76 0 0 0-.947-.37"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const Check1Icon = Icon;
export default Check1Icon;
